import { useMutation } from '@tanstack/react-query'

export const mutateAdIndex = (initParams) => {

    const mutation = useMutation({
        mutationKey: ['mutate-ad-index', initParams],
        mutationFn: async (params = {}) => {
            const res = await axios.get(route('studio.editor.api.ads.show', { ...initParams, ...params }));
            return res;
        },
    });

    return mutation;
}